<script>
  import {getContext, onMount} from 'svelte';
  import {goto} from '@sapper/app';
  import {PATHS} from '@/const/paths';
  import {userApi} from '@/api/user';
  import {doCaptcha} from '@/captcha';
  import {mc} from '@/core';
  import {fixLink$} from '@/store/lang';
  import {resetSecurity$} from '@/store/reset-security';
  import {resetSecurityType$} from '@/modules/reset-security/stream';
  import Button from '@/widgets/Button.svelte';
  import lang from '../LoginPage.lang';

  export let onSubmit;
  export let loading = false;
  export let isNeed2FA = false;
  export let email = '';
  export let dataCode = '';
  export let isDrawer = false;
  export let LG = getContext('LG');

  let count = 0;
  let otpCode = '';
  let mailCode = '';
  let disabled = false;
  let timer;

  $: updateDisabled(isNeed2FA, loading, otpCode, mailCode);

  onMount(countDown);

  function updateDisabled(isNeed2FA, loading, otpCode, mailCode) {
    if (loading || (isNeed2FA && !otpCode) || !mailCode) {
      disabled = true;
    }else{
      disabled = false;
    }
  }

  function handleSubmit() {
    onSubmit(otpCode.trim(), mailCode.trim());
  }

  function countDown() {
    count = 60;
    clearInterval(timer);
    timer = setInterval(() => {
      count--;
      if (count <= 0) {
        clearInterval(timer);
      }
    }, 1000);
    return function () {
      clearInterval(timer);
    };
  }

  async function handleDeviceCodeReSend() {
    countDown();
    const captchaResult = await doCaptcha('login');
    const query = {type: 'new_device_login_verify', email, ...captchaResult};
    const params = {email};
    const {data, error} = await userApi.publicCodesMailPost(query, params);
    if (data) {
      mc.send('toast', 'info', {message: LG(lang.VerificationReSend)});
    }
    if (error) {
      mc.send('toast', 'error', error);
    }
  }

  function handleClickReset() {
    resetSecurity$.set({email, code: dataCode});
    resetSecurityType$.next({balanceType: 0, resetRecordId: 0, resetRecordStatus: 0, remain_count: 0, code: 0, answerStatus: 0});
    goto($fixLink$(PATHS.RESET_SECURITY.pathname));
  }
</script>

<style>
  .light-gray {
    color: #c5c8ce;
  }
  .input-wrap {
    border: 1px solid #e9ecef;
    border-radius: 48px;
    height: 48px;
  }
  .input-wrap:focus-within,
  .input-wrap:hover {
    border: 1px solid var(--blue-main-hover);
  }
  .ipt {
    border: none;
    height: 88%;
    outline: none;
  }
  .ipt::-webkit-input-placeholder {
    color: var(--T3);
  }
  .ipt-c-black{
    color: #1D2029;
  }
  .ipt-c-grey{
    color: #6C6E74;
  }
  .content :global(.br48){
    border-radius: 48px;
  }
  .content .drawer{
    padding-top: 60px;
  }
  .content :global(button.primary) {
    background: var(--BTN-BG);
    color: var(--BTN-COLOR);
    border-color: var(--BTN-BG);
  }
</style>

<div class="content">
  <div class="ipt-c-black f24 fw3 lh48 pt60" class:drawer={isDrawer}>
    {LG(lang.NewDeviceLogin)}
  </div>
  <div class="mt20 ipt-c-grey f12 lh16">{@html LG(lang.NewDeviceLoginDesc, {Email: `<span class="fw3 T1">${email}</span>`})} </div>
  <slot name="sourceSite" />
  <div class="input-wrap df aic mt24 ph16">
    <i class="iconfont f18 light-gray">&#xe643;</i>
    <input class="autofill ml12 ipt f1 br48" type="text" placeholder={LG(lang.NewDeviceCode)} bind:value={mailCode} on:keypress />
    {#if count > 0}
      <span class="f12 lh16 ipt-c-black">{count}s</span>
    {:else}
      <span on:click={handleDeviceCodeReSend} class="BLUE cp">
        {LG(lang.ReSend)}
      </span>
    {/if}
  </div>
  {#if isNeed2FA === true}
    <div class="input-wrap df aic mt20 ph16">
      <i class="iconfont f18 light-gray">&#xe641;</i>
      <input class="autofill ml12 ipt f1 br48" type="text" placeholder={LG(lang.GoogleAuthenticatorCode)} bind:value={otpCode} on:keypress />
    </div>
    <div class="mt20 f12 lh16 cp T1 fw3" on:click={handleClickReset}>{LG(lang.SecurityVerificationUnavailable)}</div>
  {/if}
  <Button {loading} {disabled} class="mt20 wp100 br48" type="primary" newRadius on:click={handleSubmit}>
    {LG(lang.Confirm)}
  </Button>
</div>
